import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CustomerSignUpPage } from '@/app/Auth/pages/CustomerSignUpPage';
import { PublicPage } from '@/app/PublicPage';
import type { PageStaticData } from '@/shared/routing';
import { browserLanguageLoaded } from '@/shared/utils/internationalisation';

export const Route = createFileRoute('/auth/signup/customer')({
    staticData: { access: 'public', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({}),
    loader: () => browserLanguageLoaded(),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <PublicPage>
            <CustomerSignUpPage />
        </PublicPage>
    );
}
